<template>
  <div>
    <loading v-show="showLoader" />

    <div class="ib-main-section">
      <div class="container">
        <span class="ib-back-btn" v-if="showEndorsements === true" @click="showEndorsements = false">Back</span>
        <router-link class="ib-back-btn" v-else :to="{ name: 'PolicyServicing' }">Back</router-link>
        <div class="row">
          <div class="col-md-6 pl-0">
            <div class="d2c-class-container" style="padding-top: 77px;">
              <h2 class="listing-page-title">Endorsement Listing</h2>
            </div>
          </div>
          <div class="col-md-6 in-page-infographic">
            <img class="img-fluid" alt="icon" :src="require('@/assets/images/claim-policy-right-img.svg')" />
          </div>
        </div>
      </div>

      <div class="container multistep-box" style="margin: 50px auto 20px; text-align: center;">
        <div class="row mb-4">
          <div class="col-12 ib-border-b">
            <ul class="list-inline">
              <li class="mb-3 mb-md-0"><h1 class="ib-claim-listing">Choose Service Type</h1></li>
            </ul>
          </div>
          <div id="popularProductsAccordion" >
            <div class="panel-body">
              <div class="responsive-flex" v-if="showEndorsements" >
                <div v-for="endorsemnt in endorsement_types.filter(x => x.endorsement_type.toString().includes('risk'))" @click="EndorsementForm(endorsemnt.id, endorsemnt.endorsement_type)">
                  <div class="item-box">
                    <img class="img-fluid service-icon" alt="icon" :src="endorsemnt.icon" />
                    <h4 class="item-title">{{ endorsemnt.name }}</h4>
                  </div>
                </div>
              </div>
              <div class="responsive-flex" v-else>

<!--                //===========================-->
                <div>
                  <div class="item-box" v-if="endorsement_types.filter(x => x.endorsement_type.toString().includes('risk')).length > 0 && showEndorsements === false" @click="showEndorsements = true">
                    <img class="img-fluid service-icon" alt="icon" :src="require('@/assets/images/request cancellation.png')" />
                    <h4 class="item-title">Update Risk Detail</h4>
                  </div>
                </div>



                <div v-for="endorsemnt in endorsement_types.filter(x => !x.endorsement_type.toString().includes('risk'))" @click="EndorsementForm(endorsemnt.id, endorsemnt.endorsement_type)">
                  <div class="item-box">
                    <img class="img-fluid service-icon" alt="icon" :src="endorsemnt.icon" />
                    <h4 class="item-title">{{ endorsemnt.name }}</h4>
                  </div>
                </div>
                <div v-for="endorsemnt in beneficiary" @click="EndorsementForm(endorsemnt.id, endorsemnt.endorsement_type)">
                  <div class="item-box">
                    <img class="img-fluid service-icon" alt="icon" :src="endorsemnt.icon" />
                    <h4 class="item-title">{{ endorsemnt.name }}</h4>
                  </div>
                </div>
                <div v-for="endorsemnt in family" @click="EndorsementForm(endorsemnt.id, endorsemnt.endorsement_type)">
                  <div class="item-box">
                    <img class="img-fluid service-icon" alt="icon" :src="endorsemnt.icon" />
                    <h4 class="item-title">{{ endorsemnt.name }}</h4>
                  </div>
                </div>
                <div>
                  <div class="item-box" @click="EndorsementForm(0, 'cancellation')">
                    <img class="img-fluid service-icon" alt="icon" :src="require('@/assets/images/request cancellation.png')" />
                    <h4 class="item-title">Request Cancellation</h4>
                  </div>
                </div>
                <div @click="SubmittedRequest()">
                  <div class="item-box">
                    <img class="img-fluid service-icon" alt="icon" :src="require('@/assets/images/Submitted Requests.png')" />
                    <h4 class="item-title">Submitted Requests</h4>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import loading from '@/components/Loading/Loading'
import moment from "moment";
import _ from 'lodash';

export default {
  name: 'Endorsements',
  components: {
    loading
  },
  data() {
    return {
      showLoader: true,
      showEndorsements: false,
      beneficiary: {},
      family: {},
      general_acquisition: {},
      endorsement_types: {},
      quotation_id: this.$route.params.id
    };
  },
  created: function () {
    const self = this;
    self.getEndorsements(self.quotation_id);
  },
  computed: {

    date() {
      return moment().format('YYYY-MM-DD');
    }
  },
  methods: {
    priceFormatter(price) {
      return new Intl.NumberFormat('en-PK').format(price);
    },
    async getEndorsements(id) {
      var self = this;
      self.showLoader = true;
      await axios.get('customer/endorsement/types?customer_quotation_id=' + id).then(function (resp) {
        self.showLoader = false;
        if (resp.data.code == 200) {
          self.family = resp.data.data.family;
          self.beneficiary = resp.data.data.beneficiary;
          self.endorsement_types = resp.data.data;

        } else {
          $toast.error(resp.data.message, { position: 'top-right' });
          return false;
        }
      }).catch(function (error) {
        self.showLoader = false;
        if(error.data.errors != undefined) {
          error.data.errors.forEach(element => {
            $toast.error(element.message, { position: 'top-right' });
          });
        } else {
          $toast.error(error.data.message, { position: 'top-right' });
        }
      });
    },
    SubmittedRequest(){
      const self = this;
      self.$router.push({ name: 'SubmittedRequest', params: {id: self.quotation_id } });
    },
    EndorsementForm(id, type){
      let self = this;
      if (type.toString().includes('risk')){
        if (type == 'risk_addition'){
          self.$router.push({ name: 'EndorsementRiskAddition', params: {id: id, quotation_id: self.quotation_id } });
        }else{
          self.$router.push({ name: 'DeleteRisk', params: {id: id, quotation_id: self.quotation_id, type: type } });
        }
      }else{
        self.$router.push({ name: 'EndorsementRequestForm', params: {id: id, quotation_id: self.quotation_id, type: type } });
      }

    }
  }
};
</script>

<style scoped>
.active {
  display: block !important;
}
.tab-pane {
  display: none;
}
.claim-doc-icon p {
  font-family: "Avenir Medium";
  font-size: 14px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  letter-spacing: normal;
  text-align: left;
  color: #4c505d;
  margin-bottom: 0px;
}
.claim-data-icon img {
  margin: 0 auto;
}
/* .claim-data-icon {
  width: 121px;
  height: 124px;
  border-radius: 10px;
  border: solid 1px #e5e5e5;
  background-color: #ffffff;
  box-shadow: 0 2px 20px 0 rgba(0, 0, 0, 0.17);
  display: flex !important;
  justify-content: space-evenly;
  align-items: center;
  flex-direction: column;
} */
.claim-data-icon img{
  width: 40px;
  margin-top: 8px;
}
/* .claim-data-icon:not(:nth-of-type(1)) {
  margin-left: 15px;
  margin-right: 15px;
} */
.claim-row-sub-heading {
  font-family: "Avenir Book";
  font-size: 15px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.38;
  letter-spacing: normal;
  text-align: left;
  padding-left: 20px;
  color: #ef7c94;
  color: #ef7c94 !important;
}
.jbl-nav-tabs .nav-item .nav-link:hover, .jbl-nav-tabs .nav-item .nav-link:active, .jbl-nav-tabs .nav-item .nav-link:focus,.jbl-nav-tabs .nav-item {
  border: solid 1px transparent;
  color: #fff !important;
  height: 61px;
  border-radius: 31px;
  background-color: #def3f7;
  display: flex !important;
  align-items: center;
  justify-content: center;
}
.jbl-nav-tabs .nav-item .nav-link:hover, .jbl-nav-tabs .nav-item .nav-link:active, .jbl-nav-tabs .nav-item .nav-link:focus,.jbl-nav-tabs .nav-item .active {
  border: solid 1px var(--primary-color);
  background-color: var(--primary-color);
  color: #fff !important;
  height: 61px;
  border-radius: 31px;
  display: flex !important;
  align-items: center;
  justify-content: center;
}
.jbl-nav-tabs .nav-item .nav-link {
  color: #5b6770;
}
.jbl-nav-tabs {
  border-radius: 31px;
  box-shadow: 0 3px 26px 0 rgba(0, 0, 0, 0.08);
  background-color: #def3f7;
  border: 0;
  font-family: "Avenir Medium";
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.29;
  letter-spacing: normal;
  text-align: left;
  color: #5b6770;
  margin: 20px 0 10px 15px;
  /* padding-top: 1px;
  padding-bottom: 1px; */
}
table > tbody > tr, .data-row {
  margin: 10px 0;
  padding: 20px 30.7px 20px 15px;
  border-radius: 10px;
  box-shadow: 0 3px 26px 0 rgba(0, 0, 0, 0.08);
  border: solid 1px #dedada;
  background-color: #ffffff;
}
.data-row .action-area {
  text-align: right;
}
.data-row .action-area i {
  width: 7.9px;
  height: 14.6px;
  color: #5b6770;
}
.claim-sub-heading {
  width: 100%;
  min-height: 54px;
  margin: 20px 0px;
  padding: 16px;
  border-radius: 7px;
  /* border: dotted 2px #3d9cbd; */
  border: dashed 2px #3d9cbd;
  background-color: rgba(61, 156, 189, 0.03);
  font-family: "Avenir Heavy";
  font-size: 16px;
  /* font-weight: 900; */
  text-align: left;
  color: #ef7c94 !important;
}
.data-row .claim-sub-heading {
  font-family: "Avenir Heavy";
  font-size: 16px;
  /* font-weight: 900; */
  text-align: left;
  color: #ef7c94 !important;
}
.data-row .claim-row-sub-desc {
  color: #5b6770;
}
.data-row .status-danger {
  background-color: rgba(30, 203, 16, 0.09);
  font-size: 12px;
  font-stretch: normal;
  font-style: normal;
  color: #1ecb10;
  letter-spacing: normal;
}
.data-row .status {
  padding: 6px 24px;
  border-radius: 6px;
  font-family: "Avenir Medium";
}
.data-row .claim-row-data {
  font-family: "Avenir Medium";
  font-size: 19px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.37;
  letter-spacing: normal;
  text-align: left;
  color: #5b6770;
}
.data-row .claim-row-heading {
  font-family: "Avenir Medium";
  font-size: 22px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.32;
  letter-spacing: normal;
  text-align: left;
  color: #5b6770;
}
label {
  position: absolute;
  top: 0;
  right: 1px;
  bottom: 1px;
  left: .5em;
  z-index: 1;
  height: 1em;
  font-size: 13px;
  line-height: 3.5em;
  color: #999;
  white-space: nowrap;
  cursor: text;
  transition:all .1s ease;
}
.input-placeholder:focus ~ label, .input-placeholder:valid ~label {
  font-size:11px;
  left:10px;
  top:-10px;
}
.input-placeholder:valid ~label {
  color:green;
}
.input-placeholder:focus:invalid ~label {
  color:red;
}
.jbl-data-img{
  width: 100px;
  height: 65px;
  margin-right: .6rem;
}
.table.table-borderless td {
  padding: 1rem 0rem;
}
@media (max-width:576px) {
  nav.nav-tabs.jbl-nav-tabs{
    margin: 0 auto;
  }
  .jbl-nav-tabs .nav-item .nav-link:hover, .jbl-nav-tabs .nav-item .nav-link:active, .jbl-nav-tabs .nav-item .nav-link:focus,.jbl-nav-tabs .nav-item {
    border: solid 1px transparent;
    height: 2.2rem;
  }

  .jbl-nav-tabs .nav-item .nav-link:hover, .jbl-nav-tabs .nav-item .nav-link:active, .jbl-nav-tabs .nav-item .nav-link:focus,.jbl-nav-tabs .nav-item .active {
    border: solid 1px #007bff;
    height: 2.2rem;
  }
  .jbl-nav-tabs {
    font-size: 14px;
  }
  .nav-item .nav-link{
    padding: 0.5rem .5rem;
  }
}
dd.claim-row-data {
  font-family: "Avenir Medium";
  font-size: 19px;
  font-weight: 500;
  text-align: left;
  color: #5b6770;
  padding-left: 20px;
}
.col-md-3 p.claim-row-data:nth-of-type(2) {
  font-family: "Avenir Medium";
  font-size: 19px;
  font-weight: 500;
  text-align: left;
  color: #5b6770;
  padding-left: 20px;
}

.claim-data-icon img {
  margin: 0 auto;
}
.claim-car-icon {
  width: 165.3px;
  height: 122.9px;
  border-radius: 10px;
  border: solid 1px #e5e5e5;
  background-color: #ffffff;
  box-shadow: 0 2px 20px 0 rgba(0, 0, 0, 0.17);
  display: flex !important;
  justify-content: space-evenly;
  align-items: center;
  flex-direction: column;
  margin: 1rem !important;
  padding-left: 10px !important;
  padding-left: 10px !important;
  overflow: hidden;
}
.claim-car-icon img{
  width: 100%;
  height: auto;
  margin-top: 8px;
}
.claim-car-icon:not(:nth-of-type(1)) {
  margin-left: 15px;
  margin-right: 15px;
}
button:hover, button:focus{
  border: 1px solid transparent !important;
  outline: transparent !important;
  box-shadow: transparent !important;
  text-decoration: none !important;
}
</style>



// WEBPACK FOOTER //
// src/views/PolicyServicing/Listing.vue